import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import IconButton from "@mui/material/IconButton";
import TimezoneSelect from "../layout/TimezoneSelect";
import { useSelector } from "react-redux";
import { timezoneMappings } from "../../data/timezones";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

export default function NotaryTimeZoneSection({
  timezone,
  setTimezone,
  handleOpen,
}) {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const [currentTime, setCurrentTime] = useState(new Date());
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        marginRight: "auto",
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        flexWrap: isMediumScreen ? "wrap" : "nowrap",
      }}
    >
      {!isMobileScreen && (
        <>
          <IconButton onClick={handleOpen} sx={{ ml: 1 }} aria-label="calendar">
            <CalendarTodayIcon />
          </IconButton>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              flex: "1 1 auto",
            }}
          >
            {DateTime.fromMillis(currentTime.getTime(), { zone: "utc" })
              .setZone(timezone)
              .toFormat("MMMM dd yyyy, h:mm:ss a")}
          </span>
        </>
      )}

      <TimezoneSelect
        options={timezoneMappings}
        timezone={timezone}
        setTimezone={setTimezone}
        availabilities={currentUser?.availabilities}
      />
    </div>
  );
}
